import React from 'react'
import { ErrorScreen } from './common.coffee'

export default class ErrorBoundary extends React.Component
  constructor: (props) ->
    super props
    @state =
      hasError: false
      error: null

  logError: (error) ->
    if window.app?.trackError?
      window.app.trackError(error)
    else
      console.error "Error without app!"
      console.dir error

  componentDidCatch: (error, info) ->
    # note: the actual error tends NOT to match the actual root cause, which leads
    #     : to a lot of unnecessary and misleading logging.
    realError = info?.componentStack || error

    @setState
      hasError: true
      error: error
      realError: realError

    # log the error
    @logError(realError)

  render: ->
    if @state.hasError
      if @state.error.name is 'ChunkLoadError'
        <ErrorScreen showVersionInfo>
          <p>
            <strong>Please check your internet connection. </strong>
            Our application is having trouble reaching our servers.
            If the problem persists, please contact support, let them know that you have seen this message, and let them know which device, browser, and operating system you are using.
          </p>
        </ErrorScreen>
      else
        <ErrorScreen showVersionInfo error={@state.realError}>
          <p>
            We have encountered an error and are sending the logs to our tracking system.
            The system works best on Chrome or Safari.
            If you contact support, please let them know that you have seen this message, and let them know which device, browser, and operating system you are using.
          </p>
        </ErrorScreen>
    else
      return @props.children
